import React, { useContext, useEffect, useRef, useState } from 'react';
import EventTabRenders from '../../../components/ui/tabs/EventRenderTab';
import SwalAlert from '../../../services/swalService/SwalService';
import BasicDetailContext from '../utils/BasicDetailContext';
import BasicInformation from './BasicInformation/BasicInformation';
import AvailabilitySchedule from './AvailabilitySchedule/AvailabilitySchedule';
import Pricing from './Pricing/Pricing';
import Others from './Others/Others';
import { useAddEditEventDetailsMutation, useAddEditEventLessonTimeSlotDetailsMutation, useAddEditEventPricingDetailMutation, useAddEditOtherEventDetailsMutation } from '../../../app/services/EventManagement/EventManagementApi';
import ToastService from '../../../services/toastService/ToastService';
import { useStoreBase64ImageMutation } from '../../../app/services/common/commonServiceApi';
import { useNavigate } from 'react-router-dom';

const EventTabWrapper = () => {
    // Refs to access child components for form data
    const basicInformationRef = useRef(null);
    const availblityScheduleRef = useRef(null);
    const pricingRef = useRef(null);
    const othersRef = useRef(null);
    const navigate = useNavigate();

    const [uploadedFileName, setUploadedFileName] = useState({
        EventImage: "",
        EventImageEncImageName: "",
        SpeakerImage: "",
        SpeakerImageEncImageName: "",
    });
    const { eventId, eventTimeSlotId, setEventId, tabs, setTabs, activeTab, setActiveTab, entryType, ScheduleListData, pricingPackageDetails, addOnsData, isDietry } = useContext(BasicDetailContext);
    const { error } = SwalAlert();
    const [addEventMutation, { isLoading: addEventIsLoading, isSuccess: addEventIsSuccess, data: addEventResponse }] = useAddEditEventDetailsMutation();
    const [addEventLessionMutation, { isLoading: isLoadingLession, isSuccess: isSuccessLession, data: addEventLessionResponse }] = useAddEditEventLessonTimeSlotDetailsMutation();
    const [imageUpload, { isLoading: isImageLoading, isSuccess: isImageSuccess, data: uploadImgResponse }] = useStoreBase64ImageMutation();
    const [addEditEventPricing, { isLoading: isAddEditEventPricingLoading, isSuccess: isAddEditEventPricingSuccess, data: addEditImagePricingResponse }] = useAddEditEventPricingDetailMutation();
    const [addEditOtherSectionDetails, { isLoading: otherSectionDetailsLoading, isSuccess: otherSectionDetailsSuccess, data: addEditOtherSectionDetailsResponse }] = useAddEditOtherEventDetailsMutation();



    useEffect(() => {
        if (entryType && tabStructures[entryType]) {
            setTabs(tabStructures[entryType]);
        }
    }, [entryType, activeTab]);

    useEffect(() => {
        if (!addEventIsLoading && addEventIsSuccess && addEventResponse) {
            setEventId(addEventResponse?.keyId);
            ToastService.success("Event Data has been added successfully !");
            setActiveTab(activeTab + 1);
        }
    }, [addEventIsLoading, addEventIsSuccess, addEventResponse]);

    useEffect(() => {
        if (!isImageLoading && isImageSuccess && uploadImgResponse) {
            let storagePath = uploadImgResponse?.fileName?.split("\\")[1];
            setUploadResponseFileName(storagePath, uploadImgResponse?.uploadedFileName, uploadImgResponse?.fileName);
            ToastService.success("Image has been uploaded successfully !");
        }
    }, [isImageLoading, isImageSuccess, uploadImgResponse]);

    useEffect(() => {
        if (!isAddEditEventPricingLoading && isAddEditEventPricingSuccess && addEditImagePricingResponse) {
            if (addEditImagePricingResponse.keyId > 0)
                ToastService.success("Pricing updated successfully.");
        }
    }, [isAddEditEventPricingLoading, isAddEditEventPricingSuccess, addEditImagePricingResponse]);

    useEffect(() => {
        if (!otherSectionDetailsLoading && otherSectionDetailsSuccess && addEditOtherSectionDetailsResponse) {
            if (addEditOtherSectionDetailsResponse.keyId > 0) {
                ToastService.success("Other details updated successfully.");
                navigate("/viewEditEvent");
            }
        }
    }, [otherSectionDetailsLoading, otherSectionDetailsSuccess, addEditOtherSectionDetailsResponse]);

    const tabStructures = {
        1: [
            { id: 0, label: "Basic Information", component: <BasicInformation ref={basicInformationRef} imageUpload={imageUpload} />, saveInto: "BasicInformation", isDisable: false },
            { id: 1, label: "Availability & Schedule", component: <AvailabilitySchedule ref={availblityScheduleRef} />, saveInto: "AvailabilitySchedule", isDisable: false },
            { id: 3, label: "Pricing", component: <Pricing ref={pricingRef} />, saveInto: "Pricing", isDisable: false },
            { id: 4, label: "Others", component: <Others ref={othersRef} />, saveInto: "Others", isDisable: false },
        ],
        2: [
            { id: 0, label: "Basic Information", component: <BasicInformation ref={basicInformationRef} />, saveInto: "BasicInformation", isDisable: false },
            { id: 1, label: "Availability & Schedule", component: <AvailabilitySchedule ref={availblityScheduleRef} />, saveInto: "AvailabilitySchedule", isDisable: false },
            { id: 2, label: "Programme", component: <h1>Programme</h1>, saveInto: "Programme", isDisable: false },
            { id: 3, label: "Pricing", component: <Pricing ref={pricingRef} />, saveInto: "Pricing", isDisable: false },
            { id: 4, label: "Others", component: <Others ref={othersRef} />, saveInto: "Others", isDisable: false },
        ],
        3: [
            { id: 0, label: "Basic Information", component: <BasicInformation ref={basicInformationRef} />, saveInto: "BasicInformation", isDisable: false },
            { id: 5, label: "Questions", component: <h1>Questions</h1>, saveInto: "Questions", isDisable: false },
        ],
    };

    // Function to handle tab navigation
    const handleBack = (tab) => setActiveTab(tab);
    const handleRedirectTabs = (tab) => setActiveTab(tab);

    // Function to handle next tab navigation
    const handleNextTab = (tabName, label) => {
        // Validate form data for Basic Information tab
        if (tabName === "BasicInformation") {
            const basicInformationData = basicInformationRef.current.getFormData();
            if (basicInformationData) {
                const request = {
                    EventId: eventId || null,
                    EventCode: null,
                    EventName: basicInformationData?.name || null,
                    EventTypeId: basicInformationData?.entryType?.value || null,
                    EventTopicId: basicInformationData?.entryTopic?.value || null,
                    EventImage: uploadedFileName?.EventImage || null,
                    EventImageEncryptedName: uploadedFileName?.EventImageEncImageName || null,
                    EventRegistrationApproval: basicInformationData?.isApproval === "yes" || false,
                    EventNotificationPeriod: basicInformationData?.notificationPeriod || null,
                    EventAbout: basicInformationData?.about || null,
                    OutlineDescription: basicInformationData?.outlines || null,
                    SpeakerDescription: basicInformationData?.speaker || null,
                    ReadMoreDescription: basicInformationData?.readMore || null,
                    IsDietaryRequirement: null,
                    SpeakerImage: uploadedFileName?.SpeakerImage || null,
                    SpeakerImageEncryptedName: uploadedFileName?.SpeakerImageEncImageName || null,
                    EventFormStartDate: null,
                    EventFormEndDate: null,
                    EventSalesEndDate: null,
                    IsAttendanceFree: null,
                    EventFormEndTime: null,
                    WorkshopFlagTag: basicInformationData?.flagTag || null,
                    IsCreditAllow: null,
                    BannerImage: null,
                    AdditionalDescription: [],
                    AdditionalSpeaker: [],
                    AdditionalModerator: [],
                    AdditionalGuest: [],
                }
                addEventMutation(request)
            } else {
                error("Please fill all mandatory fields.", "");
            }
        }
        // Validate form data for Availability Schedule tab
        else if (tabName === "AvailabilitySchedule") {
            // const basicInformationData = basicInformationRef.current.getFormData();
            if (ScheduleListData?.length > 0) {
                ToastService.success("Event Data has been added successfully !");
                setActiveTab(activeTab + 1);
            } else {
                error("Please Generate Schedule for events.", "");
            }
        }
        // Validate form data for Availability Schedule tab
        else if (tabName === "Pricing") {
            debugger
            if (label !== "Save") {
                setActiveTab(prev => prev + 1);
            }
            updatePricingDetails();
        }
        else if (tabName === "Others") {
            const othersData = othersRef.current.getFormData();
            let otherRequest = {
                EventId: eventId,
                IsDietaryRequirement: isDietry,
                IsQuestion: false,
                NotificationEmail: othersData?.decisionComment,
                Questions: [],
            }
            addEditOtherSectionDetails(otherRequest);
        }
    };

    const updatePricingDetails = () => {
        const pricing = pricingRef.current.pricingRef.getFormData();
        const additionalGuest = pricingRef.current.additionalGuestRefData.getFormData();
        const additionalAddOn = pricingRef.current.additionalAddOnRef.getFormData();

        let pricingPackage = [...pricingPackageDetails]

        pricingPackage = pricingPackage.reduce((previousValue, currentValue, currentIndex) => {
            debugger
            let finalPricingArray = previousValue;
            let birds = [{
                EventPriceId: 0,
                EventPackageId: 0,
                EarlyBirdPrice: parseFloat(currentValue.earlyBird),
                EarlyBirdCredit: 0,
                IsSuperEarlyBirdPrice: false,
                PromotionStartDate: currentValue.earlyPromotionStartDate,
                PromotionEndDate: currentValue.earlyPromotionendDate,
                MaxQuantity: Number(currentValue.earlyMaxQuantity),
            },
            {
                EventPriceId: 0,
                EventPackageId: 0,
                EarlyBirdPrice: parseFloat(currentValue.superEarlyBird),
                EarlyBirdCredit: 0,
                IsSuperEarlyBirdPrice: true,
                PromotionStartDate: currentValue.superEarlyPromotionStartDate,
                PromotionEndDate: currentValue.superEarlyPromotionendDate,
                MaxQuantity: Number(currentValue.superEarlyMaxQuantity),
            },]

            let entryPackage = {
                EventPackageId: 0,
                EventPackageName: currentValue.eventPackageName,
                EventPrice: parseFloat(currentValue.eventPrice),
                EventCredit: 0,
                EntryPackagePrice: birds,
            }
            finalPricingArray.push(entryPackage);
            return finalPricingArray;
        }, [])

        let eventPricingAddOns = [...addOnsData];
        const request = {
            EventId: eventId,
            EventTimeSlotId: eventTimeSlotId,
            IsAttendanceFree: pricing?.isAttandance === "There is a cost to attend" ? false : true,
            EventSalesEndDate: 0,
            AdditionalGuestCorporate: null,
            AdditionalGuestIndividual: additionalGuest?.isQuantityAllow ? 0 : additionalGuest?.maxGuest?.value || 0,
            IsEventAddOn: additionalAddOn.isAdditionalAddOns === "There is additional fee" ? true : false,
            IsQuantityAllow: additionalGuest?.maxGuest?.value > 0 ? false : additionalGuest?.isQuantityAllow || false,
            EntryPackage: pricingPackage,
            EntryPackageAddOn: additionalAddOn.isAdditionalAddOns === "There is additional fee" ? eventPricingAddOns : [],
        }
        addEditEventPricing(request);
    }

    const setUploadResponseFileName = (fieldName, fileName, encFileName) => {
        const validFields = {
            EventImage: "EventImageEncImageName",
            SpeakerImage: "SpeakerImageEncImageName",
        };
        if (validFields[fieldName]) {
            setUploadedFileName((prevState) => ({
                ...prevState,
                [fieldName]: fileName,
                [validFields[fieldName]]: encFileName,
            }));
        }
    };

    return (
        <React.Fragment>
            <EventTabRenders
                activeTab={activeTab}
                tabs={tabs}
                showBackButtonIndex={0}
                handleBack={handleBack}
                handleNextTab={handleNextTab}
                handleRedirectTabs={handleRedirectTabs}
            />
        </React.Fragment>

    );
};

export default EventTabWrapper;
